import { useState, useEffect } from "react";
import { Volume2, Square } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { speak, stopSpeaking } from "../lib/voice";

// Speaks the given text using Web Speech API + user's saved voice preferences.
export default function SpeakButton({ text, testid = "speak-btn" }) {
  const { lang, t } = useLang();
  const [speaking, setSpeaking] = useState(false);
  const supported =
    typeof window !== "undefined" && "speechSynthesis" in window;

  useEffect(() => {
    return () => {
      if (supported) window.speechSynthesis.cancel();
    };
  }, [supported]);

  if (!supported || !text) return null;

  const onSpeak = () => {
    const utter = speak(text, lang);
    if (!utter) return;
    utter.onend = () => setSpeaking(false);
    utter.onerror = () => setSpeaking(false);
    setSpeaking(true);
  };

  const onStop = () => {
    stopSpeaking();
    setSpeaking(false);
  };

  return (
    <button
      type="button"
      onClick={speaking ? onStop : onSpeak}
      data-testid={testid}
      aria-label={speaking ? t("stop") : t("listen")}
      className={`inline-flex items-center gap-2 rounded-full border-2 px-4 py-2 text-base font-semibold transition-colors ${
        speaking
          ? "border-[#A762B1] bg-[#A762B1] text-white"
          : "border-[#101A42] bg-white text-[#101A42] hover:bg-[#101A42] hover:text-white"
      }`}
    >
      {speaking ? (
        <>
          <Square className="h-4 w-4" strokeWidth={2.5} />
          {t("stop")}
        </>
      ) : (
        <>
          <Volume2 className="h-4 w-4" strokeWidth={2.5} />
          {t("listen")}
        </>
      )}
    </button>
  );
}
